import { useEffect, useState } from 'react';

export async function generateQrDataUrl(value: string, size = 100) {
  const module = await import('qrcode');
  return module.toDataURL(value, { width: size * 2, margin: 1, errorCorrectionLevel: 'M', color: { dark: '#172b4d', light: '#ffffff' } });
}

export function QrCodeImage({ value, label, size = 100, raw = false, phoneSave = false }: { value: string; label: string; size?: number; raw?: boolean; phoneSave?: boolean }) {
  const [source, setSource] = useState('');
  const [message, setMessage] = useState('');
  const encodedValue = raw || /^https?:\/\//i.test(value) ? value : `${window.location.origin}/table-order/${encodeURIComponent(value)}`;
  useEffect(() => {
    let active = true;
    if (!value) { setSource(''); return () => { active = false; }; }
    generateQrDataUrl(encodedValue, size).then(url => { if (active) setSource(url); });
    return () => { active = false; };
  }, [value, encodedValue, size]);
  const fileName = `${label.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}-qr.png`;
  const saveToPhone = async () => {
    if (!source) return;
    try {
      const blob = await (await fetch(source)).blob();
      const file = new File([blob], fileName, { type: 'image/png' });
      if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
        await navigator.share({ title: `${label} QR code`, text: 'Save this customer QR image to your phone.', files: [file] });
        setMessage('Image save options opened.');
        return;
      }
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url; anchor.download = fileName; anchor.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 2_000);
      setMessage('QR image downloaded.');
    } catch (error) {
      if ((error as DOMException).name !== 'AbortError') setMessage('Press and hold the QR image to save it.');
    }
  };
  if (!value) return null;
  return <span className="legacy-qr-code"><img src={source} width={size} height={size} alt={`${label} QR code`}/><small>{encodedValue}</small>{phoneSave ? <button type="button" onClick={saveToPhone}>Save QR image</button> : <a href={source} download={fileName}>Download QR image</a>}{message && <em role="status">{message}</em>}</span>;
}
